import classNames from 'classnames'
import React from 'react'
import {connect} from 'react-redux'
import PropTypes from 'prop-types'

import {closeSlidingModal} from '../actions/modal'
import ModalCloseButton from './ModalCloseButton'

import * as dashboard from '../store/dashboard'

import '../../scss/components/sliding-modal/_sliding-modal.scss'

const SlidingFullScreenModal = ({children, isOpen, onClose}) => (
  <div
    className={classNames('sliding-modal-container', {
      'is--showing': isOpen,
    })}
  >
    <div className="sliding-modal">
      <ModalCloseButton onClick={onClose} />
      {children}
    </div>
    <div className="curtain" />
  </div>
)

SlidingFullScreenModal.propTypes = {
  children: PropTypes.element,
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
}

const mapStateToProps = (state) => ({
  isOpen: dashboard.slidingModalIsOpen(state),
  children: dashboard.slidingModalContent(state),
})

const mapDispatchToProps = (dispatch) => ({
  onClose: () => dispatch(closeSlidingModal()),
})

export default connect(mapStateToProps, mapDispatchToProps)(SlidingFullScreenModal)
